<template>
	<v-layout row>
	<v-flex xs4>		
		<v-card class="mt-2" :height="$vuetify.breakpoint.width > 1920 ? '500' : '500' ">
			<v-toolbar flat class="depttoolbar">
			
				<v-toolbar-title class="body-1">
		      		DEPARTMENTS
		    	</v-toolbar-title>
		
			<v-spacer></v-spacer>
			<v-toolbar-items>
			
			<v-tooltip left v-if="isSuperUser || isManagerOfRoom(room)">
				<EditDepartmentsDialog :add='true' :room="room" 
					slot="activator" 
					v-on:refresh="refreshRoom"/>
				<span>Edit Assignments</span>
			</v-tooltip>
			
			</v-toolbar-items>
			
			</v-toolbar>
		
		<v-list class="pt-0 deptscroller">
			<v-list-tile 
				v-for="(dept, index) in room.PCT" 
				:key="index"
				class="deptlist"
        		:class="darkTheme ? { selectedDark : deptSelectedIndex == index } : { selected : deptSelectedIndex == index }"
				@click="clickHandler(index)">
				<v-layout column>
					<v-layout row align-center>
						<v-flex xs2 class="ml-2 body-1">{{dept.deptID}}</v-flex>
						<v-flex xs6 class="ml-2 body-1">{{dept.deptName}}</v-flex>  
						
						<v-flex xs1 v-if="isManagerOfDept(dept)" >
							<v-tooltip top>
			            		<AddUserDepartment  
			            				style="position: relative; top:-1px; left:-10px;"
						            	slot="activator" 
						            	:room="room"
						            	:deptPCT="dept"						            	 
						            	v-on:success="refreshRoom"/>
			            		<span>Add/Change User Dept</span>
			            	</v-tooltip>
			            </v-flex>
			            <v-flex xs2 class="body-1 text-xs-right">{{dept.percentage}}%</v-flex>
					</v-layout>
					<v-layout v-if="dept.userDeptID" row align-center>
						<v-flex xs2 class="ml-2 caption"></v-flex>
						<v-flex class="ml-2 caption">userDept: {{dept.userDeptName}} ({{dept.userDeptID}})</v-flex>
					</v-layout>
				</v-layout>
			</v-list-tile>
		</v-list>
		</v-card>
	</v-flex>

	<v-flex xs8 class="ml-4" v-if="room.PCT[0]">
		<v-card :height="$vuetify.breakpoint.width > 1920 ? '500' : '500' ">
		<v-tabs
			grow

			:color="darkTheme ? 'grey darken-4' : 'grey lighten-4'" 
			slider-color="blue"
			class="mt-2 mr-2"
			v-model="activeTab"			
		>

			<v-tab>Occupants
				<v-tooltip top v-if="isManagerOfDept(room.PCT[this.deptSelectedIndex]) || isOccupantEditorOfDept(room.PCT[this.deptSelectedIndex]) ">
		            <AddOccupant 
		            	class="mr-2" slot="activator" v-if="activeTab==0"
		            	:deptPCT="room.PCT[this.deptSelectedIndex]"
		            	:room="room"
		            	v-on:updateLoading="(value) => { loading=value }" 
		            	v-on:success="refreshRoom"
		            	/>
		            <span>Add Occupant</span>
				</v-tooltip>
			</v-tab>

			<v-tab>Principal Investigators
				<v-tooltip top v-if="isManagerOfDept(room.PCT[this.deptSelectedIndex]) || isOccupantEditorOfDept(room.PCT[this.deptSelectedIndex])">
		            <AddPI
		            	class="mr-2" slot="activator" v-if="activeTab==1"
		            	:deptPCT="room.PCT[this.deptSelectedIndex]"
		            	v-on:updateLoading="(value) => { loading=value }" 
		            	v-on:success="refreshRoom"
		            	/>
		            <span>Add Principal Investigator</span>
				</v-tooltip>
			</v-tab>

			<v-tab v-if="isSuperUser">Programs
				<v-tooltip top>
					<v-icon slot="activator" color="grey darken-2" v-if="activeTab==2" class="ml-2" @click="addBlankProgramRow">add_circle_outline</v-icon>
					<span>Add Program</span>
				</v-tooltip>
			</v-tab>

			<v-tab v-if="isSuperUser">Accounts
				<v-tooltip top>
		            <AddAccount
		            	class="mr-2" slot="activator" v-if="activeTab==3"
		            	:deptPCT="room.PCT[this.deptSelectedIndex]"
		            	v-on:updateLoading="(value) => { loading=value }" 
		            	v-on:success="refreshRoom"
		            	/>
		            <span>Add Account</span>
				</v-tooltip>
			</v-tab>
			
			<v-tabs-items v-model="activeTab">
				
				<v-tab-item>
					<RoomDetailOccupants />
				</v-tab-item>					
				<v-tab-item>
					<RoomDetailPIs />
				</v-tab-item> 
				<v-tab-item v-if="isSuperUser">
					<RoomDetailPrograms />
				</v-tab-item>
				<v-tab-item v-if="isSuperUser">
					<RoomDetailAccounts />
				</v-tab-item>  
			</v-tabs-items>
		</v-tabs>
		</v-card>
	</v-flex>
</v-layout>

</template>

<script>
import Vuex from 'vuex'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import AddDepartment from '@/components/forms/AddDepartment'
import AddOccupant from '@/components/forms/AddOccupant'
import AddPI from '@/components/forms/AddPI'
import AddAccount from '@/components/forms/AddAccount'
import RoomDetailOccupants from '@/components/RoomViewer/RoomDetailOccupants'
import RoomDetailPIs from '@/components/RoomViewer/RoomDetailPIs'
import RoomDetailAccounts from '@/components/RoomViewer/RoomDetailAccounts'
import RoomDetailPrograms from '@/components/RoomViewer/RoomDetailPrograms'
import EditDepartmentsDialog from '@/components/forms/EditDepartmentsDialog'
import AddUserDepartment from '@/components/forms/AddUserDepartment'

export default {
data () {
	return {	deptSelect: null,
				collegeSelect: null,
				activeTab: 0,
				selectedIndex: 0,
				showX: false,
				dialog: {},
	}
},

components: { AddDepartment, AddOccupant, AddPI, AddAccount, RoomDetailOccupants, RoomDetailPIs, RoomDetailAccounts, RoomDetailPrograms, EditDepartmentsDialog, AddUserDepartment },

computed: {
	...mapState({   	room: 				state => state.dv.room,
						deptSelectedIndex: 	state => state.dv.deptSelectedIndex,
						darkTheme: 			state => state.ui.darkTheme,
						isSuperUser: 		state => state.user.isSuperUser,
				}),
	...mapGetters(['isManagerOfDept', 'isManagerOfRoom', 'isOccupantEditorOfDept']),
},

methods : {
	...mapMutations([ 	'setDeptSelectedIndex',						
						'addBlankProgramRow',
						'addBlankAccountRow',
						'insertAccount',
					]),

	...mapActions([		'fetchFullRoom',
						'deleteRoomPercentage',
						'setRoom',
				  ]),

	clickHandler : function (index) {
		this.selectedIndex = index
		this.setDeptSelectedIndex(index)
	},

	deptID: function () {
		return this.room ? this.room.PCT[this.deptSelectedIndex].deptID : []
	},

	refreshRoom: function () {
		this.fetchFullRoom({bldgAlpha: this.room.bldgAlpha, number: this.room.number, noSet: true}).then((data) => { 
			this.setRoom(data) 
		})
	},

	delRoomPercentage: function (key, index) {
		this.dialog[index] = false
		this.deleteRoomPercentage({ key: key }).then(() => this.refreshRoom())
	},


},
}

</script>

<style>
.selected {
	background-color: gainsboro;
}

.selectedDark {
	background-color: black;
}

.tightlist > .v-list__tile {
	height: auto;
	padding-top: 1px;
	padding-bottom: 1px;
}

.deptlist > .v-list__tile {
	height: auto;
	padding-top: 7px;
	padding-bottom: 7px;
}

.tightlist .v-btn {
	height: auto;
}

.depttoolbar > .v-toolbar__content {
  	height: 46px !important;
  	padding-right: 0px;
}

.deptscroller {	
	overflow-y: auto;
	overflow-x: hidden;
	height: calc(100% - 60px) !important; 
}
</style>



// WEBPACK FOOTER //
// src/components/RoomViewer/RoomDetailDepts.vue